import { render, staticRenderFns } from "./dataTag.vue?vue&type=template&id=2e8732bd&scoped=true&"
import script from "./dataTag.vue?vue&type=script&lang=js&"
export * from "./dataTag.vue?vue&type=script&lang=js&"
import style0 from "./dataTag.vue?vue&type=style&index=0&id=2e8732bd&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8732bd",
  null
  
)

export default component.exports